import React from 'react'

import { useTranslation } from "react-i18next";

import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';
import "react-calendar/dist/Calendar.css";
import './style-calendar.css'
import PropTypes from 'prop-types';
import CalendarFilterPanel from './CalendarFilterPanel';
import MainAppContext from '../../../../../MainAppContext';
import { __BoardCalendarFilter, enum__BoardCalendarFilterDisplayFormat } from '../../../../../common/Dictionaries';
import { useContext } from 'react';
import { Icon, IconButton } from '@fluentui/react';
import { useSelector } from 'react-redux';
import { CalloutFocusTrapExample } from '../BoardElementTypeBox/FieldFilter';
import { useBoolean } from '@fluentui/react-hooks';
import { BOARD_AGGREGATION_WHEN_NULL, BOARD_AGRUPATION_WHEN_NULL } from '../../../../../configurations/application.config';
import { getLocalStorageValue } from '../../../../../common/Helpers';

function CalendarFilter(props) {
    const contextSite = useContext(MainAppContext);
    const { t } = useTranslation();
    const { _boardVariableDataserieValues: boardVariableDataserieValues } = useSelector((state) => state.boardViewScope);

    const { 
        inputParam_BoardId = null,
        inputParam_ForceShowCalendar = false,
        inputParam_HideSettings = false,
    } = props;


    const [isCalendarFilterPanelOpen, setIsCalendarFilterPanelOpen] = useState(false);
    const [isCalloutVisible, { toggle: toggleIsCalloutVisible }] = useBoolean(false);

    const [groupDataseriesInOneList, setGroupDataseriesInOneList] = useState(getLocalStorageValue('PARAM_COOKIE_DATASERIES_GROUPED' + inputParam_BoardId, BOARD_AGRUPATION_WHEN_NULL));
    const [aggregationDataseries, setAggregationDataseries] = useState(getLocalStorageValue('PARAM_COOKIE_DATASERIES_AGGREGATED' + inputParam_BoardId, BOARD_AGGREGATION_WHEN_NULL));

    const onOpenCalendarFilterPanel = (e) => {
        setIsCalendarFilterPanelOpen(true)
    };

    const getFilterDisplayStringDate = () => {
        const dualDisplayDate = __BoardCalendarFilter.find(x => x.key === contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId)
        let stringDisplayDate = ""

        switch (dualDisplayDate.displayDateFormat) {
            case enum__BoardCalendarFilterDisplayFormat.range:
                let stringDisplayDate1_month = moment(contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate).format('MMM').toLowerCase()
                let stringDisplayDate2_month = moment(contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate).format('MMM').toLowerCase()
                stringDisplayDate1_month = t(`data-lang-lbl-${stringDisplayDate1_month}-short`);
                stringDisplayDate2_month = t(`data-lang-lbl-${stringDisplayDate2_month}-short`);

                let stringDisplayDate1_year = moment(contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate).format('YYYY');
                let stringDisplayDate2_year = moment(contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate).format('YYYY');

                let stringDisplayDate1 = `${stringDisplayDate1_month} ${stringDisplayDate1_year}`;
                let stringDisplayDate2 = `${stringDisplayDate2_month} ${stringDisplayDate2_year}`;

                stringDisplayDate1 = stringDisplayDate1.charAt(0).toUpperCase() + stringDisplayDate1.slice(1);
                stringDisplayDate2 = stringDisplayDate2.charAt(0).toUpperCase() + stringDisplayDate2.slice(1);
                stringDisplayDate = `${stringDisplayDate1} - ${stringDisplayDate2}`
                break;
            case enum__BoardCalendarFilterDisplayFormat.year:
                stringDisplayDate = moment(contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate).format('YYYY')
                break;
            case enum__BoardCalendarFilterDisplayFormat.month:
                let stringDisplayDate_month = moment(contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate).format('MMMM').toLowerCase()
                stringDisplayDate_month = t(`data-lang-lbl-${stringDisplayDate_month}`)
                stringDisplayDate = stringDisplayDate_month
                break;
            case enum__BoardCalendarFilterDisplayFormat.week:
                const weekOfMonth = moment(contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate).week() - moment(contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate).startOf('month').week() + 1;
                let stringDisplayDate_month_w = moment(contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate).format('MMMM').toLowerCase()
                stringDisplayDate_month_w = t(`data-lang-lbl-${stringDisplayDate_month_w}`)
                stringDisplayDate = `${stringDisplayDate_month_w} ${t('data-lang-lbl-week')} ${weekOfMonth}`
                break               
            default:
                break;
        }

        stringDisplayDate = stringDisplayDate.charAt(0).toUpperCase() + stringDisplayDate.slice(1);

        return stringDisplayDate;
    }

    return (
        <>
            <Row className='mb-2 pe-2' style={{paddingTop: '-60px'}}>
                <Col></Col>
                <Col className="col-auto mx-auto me-auto" style={{backgroundColor: "#1f7be8", color: "white", fontSize: "20px", width: 280}}>
                    <Row className='h-100'>
                        <Col className='cursor-pointer' onClick={onOpenCalendarFilterPanel}>
                            <Row className='mx-auto me-auto'>
                                <Col className='mx-auto me-auto col-auto px-0' style={{fontSize: "34px"}}>
                                    <Icon iconName='Calendar' className='my-auto ps-1 pe-3'/>
                                    <Icon iconName='SyncOccurence' className='my-auto ps-1 pe-3'/>
                                </Col>
                                <Col className={`text-center pt-1 px-0`}>
                                    <div style={{fontSize: "16px"}}>{getFilterDisplayStringDate()}</div>
                                    <div style={{fontSize: "12px"}}>{t(__BoardCalendarFilter.find(x => x.key === contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId).text)}</div>
                                </Col>
                            </Row>
                        </Col>
                        {
                            inputParam_HideSettings !== true &&
                            <Col className="col-auto m-auto ms-auto h-100 px-0" style={{backgroundColor: "white", display: 'flex', alignItems: 'center'}}>
                                <IconButton id="filter-board-field-callout-button" iconProps={{iconName: "Settings"}} onClick={toggleIsCalloutVisible} />
                                <CalloutFocusTrapExample
                                    showButton={false}
                                    isCalloutVisible={isCalloutVisible}
                                    toggleIsCalloutVisible={toggleIsCalloutVisible}
                                    inputParam_BoardId={inputParam_BoardId}
                                    inputParam_SetGroupDataseriesInOneList={setGroupDataseriesInOneList}
                                    inputParam_GroupDataseriesInOneList={groupDataseriesInOneList ?? false}
                                    inputParam_AggregationDataseries={aggregationDataseries ?? 2}
                                    inputParam_SetAggregationDataseries={setAggregationDataseries}
                                />
                            </Col>
                        }
                    </Row>
                </Col>
            </Row>
            {
                inputParam_ForceShowCalendar === true &&
                <CalendarFilterPanel inputParam_IsPanelOpen={isCalendarFilterPanelOpen} inputParam_SetterIsPanelOpen={setIsCalendarFilterPanelOpen} />
            }    
            {
                inputParam_ForceShowCalendar === false && boardVariableDataserieValues !== null &&     
                <CalendarFilterPanel inputParam_IsPanelOpen={isCalendarFilterPanelOpen} inputParam_SetterIsPanelOpen={setIsCalendarFilterPanelOpen} />
            }
        </>
    );
}

CalendarFilter.propTypes = {
};

export default CalendarFilter;